/**
 * @module app.bdc.list.formOrderContractCtrl
 *
 */
define(['angular', 'moment'], function(angular, moment) {


    function FormOrderContractCtrl(
        $rootScope,
        $scope,
        $uibModalInstance,
        $log,
        order,
        napService,
        contractTypeService,
        scenarioTypeService,
        offerService,
        multiStoresService,
        Notification
    ) {
        var self = {};
        self.order = order;
        self.contractTypes = $rootScope.orderForm.contractTypes;
        self.scenarioTypes = $rootScope.orderForm.scenarioTypes.filter(scenario => scenario.code !== 'RECONQUETE'); // il faut finir de coder le comportement pour les reconquêtes
        self.oldOfferCode = null;
        self.newOfferCode = null;
        self.modalContractOffer = self.order.offer;
        self.modalContractScenarioTypeCode = self.order.contract.scenarioType.code || 'CONQUETE';
        self.modalContractContractTypeCode = self.order.contract.contractType.code || 'LOC48';
        self.modalContractExtensionNbTills = self.order.contract.nbTillsAdded || 2;
        self.modalScanupOwned = self.order.isScanupOwned || false;
        self.modalAdditionalScanupWanted = self.order.isScanupOwned ? self.order.contract.isScanupIncluded : false;
        self.modalContractScanupIncluded = self.order.contract.isScanupIncluded;
        self.modalContractNbMonths = self.order.contract.nbMonths || 0;
        self.modalContractMonthlyPayment = self.order.contract.monthlyPayment || 0;
        self.modalContractNbMonthsFidelity = self.order.contract.nbMonthsFidelity || 0;
        self.modalContractMonthlyPaymentFidelity = self.order.contract.monthlyPaymentFidelity || 0;
        self.modalContractNbMonthsFranchise = self.order.contract.nbMonthsFranchise || 0;
        self.modalContractMonthlyPaymentFranchise = self.order.contract.monthlyPaymentFfranchise || 0;
        self.modalContractNbMonthsCalage = self.order.contract.nbMonthsCalage || 0;
        self.modalContractMonthlyPaymentCalage = 0;
        self.modalContractPreviousInstallment = self.order.contract.previousInstallment;
        self.modalContractNbMonthsTotal = 0;

        self.hasContractScenarioChanged = false;
        self.hasContractContractChanged = false;
        self.removeQuickInstallOffer = false;

        self.dateInstallation = self.order.dateInstallation ? moment(self.order.dateInstallation).toDate() : null;
        self.isDateMonthOpened = false;
        self.dateMonth = {
            datepickerMode: 'month',
            maxMode: 'month',
            minMode: 'month',
            minDate: moment().toDate()
        };
        self.multiStoresService = multiStoresService;

        // Mudetaf is not used for FLEURISTE market orders
        if (self.order.marketType.code === 'FLEURISTE') {
            self.order.contract.isMudetaf = false;
        }

        self.offerWithScanupIncluded = offerService.offerWithScanupIncluded(self.order);

        /**
         * Update isMultiStores attribute
         * @param  {Boolean} isMultiStores
         */
        self.changeMultiStores = function changeMultiStores(bool) {
            self.order.isMultiStores = bool;
            if(!bool){
                self.order.storesGroup = {name: null, rate: null};
                multiStoresService
                    .deleteStoresGroup(self.order.id)
                    .then(function (res) {
                        Notification.success('Informations enregistrées');
                    })
                    .catch(function (err) {
                        $log.error(err);
                        Notification.error('Une erreur est survenue: ' + err.data);
                    });
            }
        };

        self.changeReconquete = (bool) => {
            self.order.contract.reconquest = bool;
        }

        self.changeCession = (bool) => {
            self.order.contract.disposal = bool;
        }

        /**
         * Toggle the display of the datepicker
         */
        self.toggleDateMonth = function toggleDateMonth() {
            self.isDateMonthOpened = !self.isDateMonthOpened;
        };

        /**
         * Select the offer
         * @param  {String} offerType : materialTill | webTill
         */
        self.selectOfferType = function selectOfferType(offerType) {
            // Reset the modal each time the offer type changes
            self.resetFields(offerType);

            // Set the new offer type
            self.modalContractOffer = offerType;
        };

        /**
         * Resets the fields of the contract modal dependending on the new offer type
         * @param Object newOfferType
         */
        self.resetFields = function(offerType) {
            // Values depending on the offer type
            if (offerType.code === 'webTill') {
                self.selectContractType('LOC24');
            }
            else if (offerType.code === 'materialTill') {
                self.selectContractType('LOC48');
            }

            // Common values
            self.selectScenarioTypeCode('CONQUETE');
            self.modalContractExtensionNbTills = 2;
            self.dateInstallation = null;
            self.modalContractNbMonths = 0;
            self.modalContractMonthlyPayment = 0;
            self.modalContractNbMonthsFidelity = 0;
            self.modalContractMonthlyPaymentFidelity = 0;
            self.modalContractNbMonthsFranchise = 0;
            self.modalContractMonthlyPaymentFfranchise = 0;
            self.modalContractNbMonthsCalage = 0;
            self.modalContractMonthlyPaymentCalage = 0;
            self.modalContractPreviousInstallment = 0;
            self.modalContractNbMonthsTotal = 0;
        };

        self.checkNbMonths = function(){
            self.modalContractNbMonthsTotal = self.modalContractNbMonthsTotal > 12 ? 12 : self.modalContractNbMonthsTotal;
            let months = self.modalContractNbMonthsTotal.toString();
            if(self.order.contract.disposal){
                self.modalContractNbMonthsFidelity = parseInt(months);
                self.modalContractNbMonthsCalage = 0;
            }else if(self.modalContractNbMonthsTotal < 7){
                self.modalContractNbMonthsCalage = parseInt(months);
                self.modalContractNbMonthsFidelity = 0;
                self.modalContractNbMonthsFranchise = 0;
            } else if(self.modalContractNbMonthsTotal < 9 ){
                if (self.modalContractScenarioTypeCode === 'RENOUVELLEMENT'){
                    self.modalContractNbMonthsFidelity = 3;
                    self.modalContractNbMonthsCalage = self.modalContractNbMonthsTotal - 3;
                }
                if (self.modalContractScenarioTypeCode === 'CONQUETE')
                    self.modalContractNbMonthsFranchise = self.modalContractNbMonthsTotal - 6;
            } else {
                self.modalContractNbMonthsCalage = 6;
                if (self.modalContractScenarioTypeCode === 'RENOUVELLEMENT')
                    self.modalContractNbMonthsFidelity = self.modalContractNbMonthsTotal - 6;
                if (self.modalContractScenarioTypeCode === 'CONQUETE')
                    self.modalContractNbMonthsFranchise= self.modalContractNbMonthsTotal - 6;
            }
        }

        self.getMaxMonthsAllowed = function () {
            let maxMonthsAllowed = 0;
            if(self.modalContractScenarioTypeCode === 'CONQUETE'  && (self.modalContractContractTypeCode === 'LOC36' ||
                self.modalContractContractTypeCode === 'LOC48')){
                maxMonthsAllowed = 12;
            }
            if(self.modalContractScenarioTypeCode === 'RENOUVELLEMENT'  && (self.modalContractContractTypeCode === 'LOC36' ||
                self.modalContractContractTypeCode === 'LOC48')){
                maxMonthsAllowed = 6;
            }
            return maxMonthsAllowed;
        }

        /**
         * Select the scenario
         * @param scenarioTypeCode
         */
        self.selectScenarioTypeCode = function (scenarioTypeCode) {
            if(self.order.tills.find(till => till.tillType.code === 'FORFAIT') && scenarioTypeCode !== 'RENOUVELLEMENT'){
                Notification.error('Il y a un forfait maintient garantie sur matériel dans le bon de commande, vous ne pouvez pas sélectionner un autre type de contrat')
                return;
            }
            if(self.order.tills.find(till => till.tillType.code === 'PREMIUM_RECONDITIONNE') && ['CONQUETE', 'EXTENSION'].indexOf(scenarioTypeCode)){
                Notification.error('Il y a une caisse reconditionnée dans le bon de commande, vous ne pouvez pas sélectionner un autre type de contrat')
                return;
            }
            self.modalContractScenarioTypeCode = scenarioTypeCode;
            self.modalContractNbMonthsFidelity = 0;
            self.modalContractMonthlyPaymentFidelity = 0;
            self.modalContractNbMonthsFranchise = 0;
            self.modalContractMonthlyPaymentFranchise = 0;
            self.modalContractNbMonthsCalage = 0;
            self.modalContractPreviousInstallment = 0;
            if (scenarioTypeCode !== 'CONQUETE') {
                self.order.contract.reconquest = false;
            }
            if(scenarioTypeCode !== 'RENOUVELLEMENT'){
                self.order.contract.disposal = false;
            }
        }

        /**
         * Select contract type
         * @param  {String} contractTypeCode ACHAT | LOC36 | LOC48 | LOC60 | LOC24
         */
        self.selectContractType = function selectContractType(contractTypeCode) {
            if(self.order.cashDrawers.find(drawer => drawer.refurbished === true && contractTypeCode === 'LOC60')){
                Notification.error('Il y a un tiroir caisse reconditionné dans le bon de commande, vous ne pouvez pas sélectionner une location sur 60 mois')
                return;
            }
            if(self.order.options.find(option => option.refurbished === true && contractTypeCode === 'LOC60')){
                Notification.error('Il y a un accessoire caisse reconditionné dans le bon de commande, vous ne pouvez pas sélectionner une location sur 60 mois')
                return;
            }
            if(self.order.tills.find(till => till.tillType.code === 'FORFAIT') && contractTypeCode === 'LOC60'){
                Notification.error('Il y a un forfait maintient garantie sur matériel dans le bon de commande, vous ne pouvez pas sélectionner une location sur 60 mois')
                return;
            }
            if(self.order.tills.find(till => till.tillType.code === 'PREMIUM_RECONDITIONNE') && contractTypeCode === 'LOC60'){
                Notification.error('Il y a une caisse reconditionnée dans le bon de commande, vous ne pouvez pas sélectionner une location sur 60 mois')
                return;
            }

            if(self.order.tills.find(till => till.tillType.code === 'FORFAIT') && contractTypeCode !== 'LOC36' && self.modalContractNbMonthsFidelity > 0){
                self.modalContractNbMonthsFidelity = 0;
                self.modalContractMonthlyPaymentFidelity = 0;
                self.modalContractNbMonthsFranchise = 0;
                self.modalContractMonthlyPaymentFranchise = 0;
            }
            self.modalContractContractTypeCode = contractTypeCode;

            if (contractTypeCode === 'ACHAT') {
                self.order.contract.nbMonths = 0;
                self.order.contract.monthlyPayment = 0;
            }

            if(contractTypeCode !== 'LOC36' && contractTypeCode !== 'LOC48'){
                self.modalContractNbMonthsFidelity = 0;
                self.modalContractMonthlyPaymentFidelity = 0;
                self.modalContractNbMonthsFranchise = 0;
                self.modalContractMonthlyPaymentFranchise = 0;
                self.modalContractNbMonthsCalage = 0;
            }
        };

        /**
         * Select the nbTills to add (Extension scenario)
         * @param  {Int} nbTills 2 | 3
         */
        self.selectExtensionNbTills = function selectExtensionNbTills(nbTills) {
            self.modalContractExtensionNbTills = nbTills;
        };

        /**
         * Call NAP service to define if the Scanup has to be included in the till pack
         * @return {Boolean}
         */
        self.setScanupIncluded = function setScanupIncluded() {
            return napService.isScanupIncluded(self.modalScanupOwned, self.modalAdditionalScanupWanted);
        };

        /**
         * Define the contract for the view and the order model
         */
        self.defineContract = function () {
            // Get the old and new offer
            self.oldOfferCode = self.order.offer.code;
            self.newOfferCode = self.modalContractOffer.code;

            if (self.order.contract.scenarioType.code !== self.modalContractScenarioTypeCode) {
                self.hasContractScenarioChanged = true;
            }
            if (self.order.contract.contractType.code !== self.modalContractContractTypeCode) {
                self.hasContractContractChanged = true;
            }
            const scenario = scenarioTypeService.getScenarioTypeByCode(self.modalContractScenarioTypeCode);
            self.order.contract.scenarioType = scenario;
            self.order.business.scenarioTypeId = scenario.id;
            self.order.contract.contractType = contractTypeService.getContractTypeByCode(
                self.modalContractContractTypeCode
            );
            self.order.isScanupOwned = self.modalScanupOwned;
            if (self.offerWithScanupIncluded) {
                self.order.contract.isScanupIncluded = napService.isScanupIncluded(
                    self.modalScanupOwned,
                    self.modalAdditionalScanupWanted
                );
            }
            else {
                self.order.contract.isScanupIncluded = false;
            }

            self.order.contract.nbMonths = self.modalContractNbMonths;
            self.order.contract.monthlyPayment = self.modalContractMonthlyPayment;
            self.order.contract.nbMonthsFidelity = self.modalContractNbMonthsFidelity;
            self.order.contract.monthlyPaymentFidelity = self.modalContractMonthlyPaymentFidelity;
            self.order.contract.nbMonthsCalage = self.modalContractNbMonthsCalage;
            self.order.contract.monthlyPaymentCalage = self.modalContractMonthlyPaymentCalage;
            self.order.contract.previousInstallment = self.modalContractPreviousInstallment;
            self.order.contract.nbMonthsFranchise = self.modalContractNbMonthsFranchise;
            self.order.contract.monthlyPaymentFranchise = self.modalContractMonthlyPaymentFranchise;

            self.order.dateInstallation = self.dateInstallation
                ? moment(self.dateInstallation).format('YYYY-MM-DD')
                : null;

            const lastDate = moment(self.order.dateCreated).add({days: 60}).endOf('month');
            if (self.dateInstallation && moment(self.dateInstallation).isAfter(lastDate)) {
                self.removeQuickInstallOffer = true;
            }

            if (self.modalContractScenarioTypeCode === 'EXTENSION') {
                self.order.contract.nbTillsAdded = self.modalContractExtensionNbTills;
            }
            else {
                self.order.contract.nbTillsAdded = null;
            }

            if (self.modalContractScenarioTypeCode !== 'RENOUVELLEMENT') {
                self.order.contract.nbMonthsFidelity = 0;
                self.order.contract.monthlyPaymentFidelity = 0;
                self.order.contract.previousInstallment = 0;

                if (self.modalContractScenarioTypeCode !== 'CONQUETE' && self.modalContractScenarioTypeCode !== 'EXTENSION' ) {
                    self.order.contract.nbMonths = 0;
                    self.order.contract.monthlyPayment = 0;
                    self.order.contract.previousInstallment = 0;
                    self.modalContractNbMonthsFranchise = 0;
                    self.modalContractMonthlyPaymentFranchise = 0;
                }
            }

            // Set the new offer
            self.order.offer = self.modalContractOffer;

            if (self.modalContractScenarioTypeCode === 'PERIPHERIQUE') {
                self.order.contract.isMudetaf = false;
                self.order.tills = [];
                self.order.cashDrawers = [];

                // Delete old options
                for (var i = self.order.options.length - 1; i >= 0; i--) {
                    if (
                        self.order.options[i].optionType.code !== 'SCANUP' &&
                        !self.order.options[i].isTPEDevice &&
                        self.order.options[i].optionType.code !== 'DEFAUT' &&
                        self.order.options[i].optionType.code !== 'FLASHUP'
                    ) {
                        self.order.options.splice(i, 1);
                    }
                }
            }
            if((self.order.contract.previousInstallment === null || self.order.contract.previousInstallment.toFixed(2).trim() === '' || self.order.contract.previousInstallment === 0)
                && self.modalContractScenarioTypeCode === 'RENOUVELLEMENT' && self.modalContractContractTypeCode !== 'ACHAT'){
                Notification.error('Vous devez saisir la mensualité précédente.')
                return;
            }
            self.ok();
        };

        self.ok = function() {
            var result = {
                hasContractScenarioChanged: self.hasContractScenarioChanged,
                hasContractContractChanged: self.hasContractContractChanged,
                oldOfferCode: self.oldOfferCode,
                newOfferCode: self.newOfferCode,
                removeQuickInstallOffer: self.removeQuickInstallOffer
            };

            $uibModalInstance.close(result);
        };

        self.cancel = function() {
            $uibModalInstance.dismiss('cancel');
        };

        /**
         * Check if the fidelity bonus can be displayed
         * fidelity bonus form must be hidden when offer are not proposed
         */
        self.displayFidelityBonus = function () {
            const isFidelityBonusDisabled = false;
            return isFidelityBonusDisabled
                ? false
                : self.order.orderType.code !== 'NAP' &&
                    self.modalContractScenarioTypeCode === 'RENOUVELLEMENT' &&
                ((self.modalContractContractTypeCode !== 'ACHAT' &&
                      self.modalContractContractTypeCode !== 'LOC60') /*&&
                (self.order.tills.find(till => till.tillType.code === 'FORFAIT') ? self.modalContractContractTypeCode === 'LOC36' : true )*/)
                ;
        };

        self.displayFranchise = function () {
            const isFranchiseDisabled = false;
            return isFranchiseDisabled
                ? false
                : self.order.orderType.code !== 'NAP' &&
                self.modalContractScenarioTypeCode === 'CONQUETE' &&
                ((self.modalContractContractTypeCode !== 'ACHAT' &&
                    self.modalContractContractTypeCode !== 'LOC60') /*&&
                (self.order.tills.find(till => till.tillType.code === 'FORFAIT') ? self.modalContractContractTypeCode === 'LOC36' : true )*/)
                ;
        };

        self.displayCalage = function () {
            const isCalageDisabled = false;
            return isCalageDisabled
                ? false
                : self.order.orderType.code !== 'NAP' &&
                ((self.modalContractScenarioTypeCode === 'RENOUVELLEMENT' && !self.order.contract.disposal) || self.modalContractScenarioTypeCode === 'CONQUETE'  ) &&
                ((self.modalContractContractTypeCode !== 'ACHAT' &&
                    self.modalContractContractTypeCode !== 'LOC60') /*&&
                (self.order.tills.find(till => till.tillType.code === 'FORFAIT') ? self.modalContractContractTypeCode === 'LOC36' : true )*/)
                ;
        };

        return self;
    }

    FormOrderContractCtrl.$inject = [
        '$rootScope',
        '$scope',
        '$uibModalInstance',
        '$log',
        'order',
        'napService',
        'contractTypeService',
        'scenarioTypeService',
        'offerService',
        'multiStoresService',
        'Notification'
    ];

    angular
        .module('app.bdc.list.formOrderContractCtrl', ['ui.bootstrap.modal'])
        .controller('FormOrderContractCtrl', FormOrderContractCtrl);
});
